const TagEndpoints = {
  GET_TAGS_BY_WORKSPACE: (workspaceId: string) => `/tags/?workspace_id=${workspaceId}`,
  CREATE_TAG: "/tags/",
  UPDATE_TAG: (tagId: string) => `/tags/${tagId}/`,
};

export default TagEndpoints;
